import React from "react";

const PrivacyPolicy = () => (
  <div className="container mx-auto px-4 py-8 max-w-2xl bg-white rounded-lg shadow-md mt-8">
    <h2 className="text-2xl font-bold mb-4">Privacy Policy</h2>
    <p className="mb-4">
      The Tennis Strings respects your privacy. This application does not
      collect, store, or share any personal information or audio recordings. All
      audio processing is performed locally in your browser and is not
      transmitted to any server.
    </p>
    <p className="mb-4">
      We use Google Analytics to collect anonymous usage data to help improve
      the application. No personally identifiable information is collected
      through analytics.
    </p>
    <p className="mb-4">
      By using this application, you agree to this privacy policy. If you have
      any questions or concerns, please contact us.
    </p>
    <p className="text-sm text-gray-500">Last updated: April 20, 2025</p>
  </div>
);

export default PrivacyPolicy;
